import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/plan/view/license.plan.terms.query.gql"
import type {
  LicensePlanTermsQuery,
  LicensePlanTermsQueryVariables,
} from "@/v2-backoffice-client/license/plan/view/__types__/license.plan.terms.query"

type Options = QueryHookOptions<
  LicensePlanTermsQuery,
  LicensePlanTermsQueryVariables
>

export function useLicensePlanTermsQuery(options?: Options) {
  return useQuery<LicensePlanTermsQuery, LicensePlanTermsQueryVariables>(
    query,
    options,
  )
}
